import { ReactElement, CSSProperties } from "react";

export function ColorBlocks({
    id,
    className,
    style
}: {
    id?: string;
    className?: string;
    style?: CSSProperties;
}): ReactElement {
  const lg = "#60AADB";
  const md = "#8B257C";
  const sm = "#42967D";

    return (
      <svg
      id={id}
      className={className}
      style={style}
      width="352"
      height="352"
      viewBox="0 0 352 352"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
  >
      <rect width="66%" height="66%" fill={lg} />
      <rect x="66%" y="66%" width="34%" height="34%" fill={md} />
      <rect x="66%" y="50%" width="16%" height="16%" fill={sm} />
  </svg>
    );
}
